module.exports = __webpack_public_path__ + "assets/img/page-title-cfb4ec45.png";